// extracted by mini-css-extract-plugin
module.exports = {"gradientBorder":"style_gradientBorder__M0TLy","warningBorder":"style_warningBorder__pnpS3","optionWrap":"style_optionWrap__lxkTN","boxHeader":"style_boxHeader__9pefO"};